import { render, staticRenderFns } from "./Patmatch.vue?vue&type=template&id=8ea22248&scoped=true"
import script from "./Patmatch.vue?vue&type=script&lang=js"
export * from "./Patmatch.vue?vue&type=script&lang=js"
import style0 from "./Patmatch.vue?vue&type=style&index=0&id=8ea22248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea22248",
  null
  
)

export default component.exports